import { motion } from "framer-motion";
import { Droplets, Filter, Gauge, MessageCircle } from "lucide-react";
import { IMAGES, waLink, SERVICE_MESSAGES } from "@/lib/constants";

const EASE = [0.16, 1, 0.3, 1];

const ITEMS = [
  { icon: Droplets, title: "Óleo", desc: "Especificação exata do fabricante do seu motor." },
  { icon: Filter, title: "Filtro", desc: "Filtros de qualidade: óleo, ar e combustível." },
  { icon: Gauge, title: "Conferência", desc: "Verificação dos níveis de todos os fluidos." },
];

export const OilDetail = () => (
  <section id="troca-de-oleo" className="py-20 lg:py-28 bg-ink">
    <div className="px-4 sm:px-6 lg:px-10 max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative order-2 lg:order-1"
      >
        <img
          src={IMAGES.oil}
          alt="Troca de óleo sendo realizada"
          loading="lazy"
          className="w-full h-[380px] lg:h-[520px] object-cover border border-white/[0.08]"
        />
        <span className="absolute top-5 right-5 bg-volt text-ink font-display font-bold uppercase tracking-wide text-sm px-4 py-2">
          Óleo + Filtro + Conferência
        </span>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="order-1 lg:order-2"
      >
        <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-gray-500 mb-6">
          <span className="text-signal">03</span>
          <span className="h-px w-10 bg-signal/60" />
          Troca de Óleo
        </p>
        <h2 className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white">
          O óleo certo ajuda a <span className="text-signal">proteger o motor.</span>
        </h2>
        <p className="mt-6 text-sm sm:text-base text-gray-400 leading-relaxed max-w-xl">
          Cada motor possui uma especificação própria de lubrificante. Utilizar o
          produto correto — na viscosidade e no padrão indicados pelo fabricante —
          é fundamental para a vida útil e o desempenho do seu veículo.
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {ITEMS.map((item) => (
            <div key={item.title} className="border border-white/[0.08] bg-card p-5">
              <item.icon className="h-6 w-6 text-signal" />
              <h3 className="mt-3 font-display font-bold uppercase text-lg text-white">{item.title}</h3>
              <p className="mt-1.5 text-xs text-gray-400 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <p className="mt-8 border-l-2 border-volt pl-4 text-sm italic text-gray-300">
          "Não espere o motor apresentar problemas para fazer a manutenção."
        </p>

        <a
          data-testid="oil-whatsapp-button"
          href={waLink(SERVICE_MESSAGES.oil)}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cut mt-8 inline-flex items-center gap-2 px-8 py-4 bg-signal hover:bg-signalhover text-white font-display font-bold uppercase tracking-wide text-lg transition-colors duration-300"
        >
          <MessageCircle className="h-5 w-5" />
          Agendar Troca de Óleo
        </a>
      </motion.div>
    </div>
  </section>
);
